<template>
  <div
    id="modal"
    class="ui active page dimmer"
    @keydown.esc="reject"
    @keyup.enter="resolve"
    :class="{ showing: ctrl._showing }"
    @click="reject"
  >
    <div class="ui active modal" :class="modalClasses" @click.stop="">
      <slot name="header">
        <div class="header" v-if="ctrl.header">{{ ctrl.header }}</div>
      </slot>
      <div class="content">
        <slot>
          <p>{{ ctrl.body }}</p>
        </slot>
      </div>
      <div class="actions">
        <div
          class="ui button"
          @click="reject"
          v-if="negLabel.text"
          :class="[negLabel.color || '', negLabel.disabled ? 'disabled' : '']"
        >
          {{ negLabel.text }}
        </div>
        <div
          class="ui button"
          @click="resolve"
          :class="[posLabel.color || 'green', posLabel.disabled ? 'disabled' : '']"
        >
          {{ posLabel.text || $t('OK') }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#modal.dimmer {
  transition: all 0.5s;
  opacity: 0;
  visibility: hidden;
  .modal {
    transition: all 1s;
    margin-top: 20px !important;
  }
}

#modal.dimmer.showing {
  opacity: 1;
  visibility: visible;
  .modal {
    margin-top: 0px !important;
  }
}

#modal .header {
  text-transform: capitalize;
}
</style>
<script>
// @flow
const labelFor = l => {
  if (l) {
    return {
      ...l,
      text: (l && l.text) || l,
      color: l && l.color
    }
  }
  return null
}

export function ModalController(ctrl) {
  if (ctrl) {
    this.header = ctrl.header
    this.body = ctrl.body
    this.positiveLabel = labelFor(ctrl.positiveLabel)
    this.negativeLabel = labelFor(ctrl.negativeLabel)
  }

  // Internal state
  this._showing = false
  this._resolve = null
  this._reject = null

  this.show = (header, body) => {
    console.debug('showing modal')
    if (header) this.header = header
    if (body) this.body = body
    this._showing = true
    return new Promise((resolve, reject) => {
      this._resolve = resolve
      this._reject = reject
    })
  }

  this.hide = () => {
    if (this._showing) {
      if (this._reject) this._reject()
      this._showing = false
    }
  }

  this.toggle = () => {
    if (this._showing) {
      this.hide()
    } else {
      return this.show()
    }
  }
}

export default {
  name: 'modal',
  props: {
    ctrl: {
      type: ModalController,
      default: () => new ModalController()
    },
    modalClasses: {
      type: Array,
      default: () => []
    },
    positiveLabel: { type: Object, default: () => null },
    negativeLabel: { default: () => null }
  },

  computed: {
    posLabel() {
      return this.ctrl.positiveLabel || labelFor(this.positiveLabel) || {}
    },
    negLabel() {
      return this.ctrl.negativeLabel || labelFor(this.negativeLabel) || {}
    }
  },

  methods: {
    resolve() {
      if (this.posLabel.disabled) return

      const done = () => {
        this.ctrl._resolve()
        this.ctrl._showing = false
        this.$emit('closed')
      }
      if (this.positiveLabel && this.positiveLabel.onclick) {
        if (this.positiveLabel.onclick()) {
          done()
        }
      } else {
        done()
      }
    },

    reject() {
      if (this.negativeLabel && this.negativeLabel.onclick) this.negativeLabel.onclick()
      else if (this.ctrl) this.ctrl.hide()
      this.$emit('closed')
    }
  }
}
</script>
